<div class="policy-summary">
  <h3 class="policy-summary__intro policy-summary__heading--top">
    <span *ngIf="isInForce()" class="policy-summary__heading-item">Your Annuity</span>
    <span *ngIf="!isInForce()" class="policy-summary__heading-item">Your Application</span>
  </h3>
  <h3 class="policy-summary__heading-medium policy-summary__heading--bottom">
    <div class="policy-summary__heading-item">
      <span class="policy-summary__face-amount">
        {{ formatFace(initialPurchaseAmount) }}
      </span>
      <span class="policy-summary__policy-description">
        {{ getProductName() }}
      </span>
    </div>
  </h3>
</div>
